import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Toast, ToastContainer } from 'react-bootstrap';
import { MDBInput, MDBCheckbox, MDBTable, MDBTableBody } from 'mdb-react-ui-kit';
import '../styles/AddToShortlist.css';
import ListIcon from '../assets/icons/edit-list-icon.svg';
import AddToList from '../assets/icons/add-list.svg';
import { insertShortlist, updateShortlist, getShortlists } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const AddToShortlist = ({ selectedInfluencers, closeModal, openModal, sendToastMessage }) => {
    const [showModal, setShowModal] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [listName, setListName] = useState('');
    const [selectedShortlists, setSelectedShortlists] = useState([]);
    const [shortlists, setShortlists] = useState([]);
    const { email,  username } = useAuth();

    useEffect(() => {
        const fetchShortlists = async () => {
            try {
                const { data } = await getShortlists();
                setShortlists(data);
            } catch (error) {
                console.error('Error fetching shortlist data:', error);
            }
        };

        fetchShortlists();
    }, [openModal]);

    const toggleShortlistSelection = (id) => {
        setSelectedShortlists(prev => prev.includes(id) ? prev.filter(sid => sid !== id) : [...prev, id]);
    };

    const handleAddToShortlist = async () => {
        console.log(selectedInfluencers);
        const selectedInfluencerIds = selectedInfluencers.map(influencer => influencer.influencerId.toString());
        
        // Track updates to avoid modifying state multiple times before API completes
        let updatedShortlists = [...shortlists];
    
        // Process each selected shortlist
        for (const shortlist of shortlists) {
            if (selectedShortlists.includes(shortlist.id)) {
                let existingInfluencerIds = new Set(shortlist.influencerIds ? shortlist.influencerIds.split(',') : []);        
                selectedInfluencerIds.forEach(id => existingInfluencerIds.add(id));
                const removeDuplicates = [...new Set(existingInfluencerIds)]
                let updatedInfluencerIds = Array.from(removeDuplicates).join(',');
        
                let updatedShortlist = { ...shortlist, influencerIds: updatedInfluencerIds };
                
                try {
                    // Call API to update shortlist
                    await updateShortlist(updatedShortlist);
                    sendToastMessage(`Shortlist "${shortlist.name}" updated successfully!`, 'green');
        
                    // Update state (only update the relevant shortlist in the list)
                    updatedShortlists = updatedShortlists.map(s =>
                        s.id === shortlist.id ? updatedShortlist : s
                    );
                } catch (error) {
                    console.error(`Failed to update shortlist "${shortlist.name}":`, error);
                    sendToastMessage(`Failed to update shortlist "${shortlist.name}"`, 'red');
                }
            }
        }
        
        // Final state update after all API calls complete
        setShortlists(updatedShortlists);
        setSelectedShortlists([]);
        closeModal();
    };
    

    const handleAddNewShortlist = async () => {
        if (!listName.trim()) {
            sendToastMessage('Please enter a valid list name.', 'red');
            return;
        }

        // Check for duplicate list names (case-insensitive)
        const isDuplicate = shortlists.some(shortlist => shortlist.name.toLowerCase() === listName.toLowerCase());
        if (isDuplicate) {
            sendToastMessage(`A list named "${listName}" already exists.`, 'red');
            return;
        }

        const influencerIds = selectedInfluencers.map(influencer => influencer.influencerId).join(',');

        try {
            await insertShortlist({ name: listName, influencerIds, userEmail: email, username: username });
            sendToastMessage(`New shortlist "${listName}" created successfully!`, 'green');
        } catch (error) {
            console.error('Failed to add new shortlist:', error);
            sendToastMessage('Failed to add new shortlist', 'red');
        } finally {
            setListName('');
            setSelectedShortlists([]);
            setShowModal(false);
            closeModal();
        }
    };

    return (
        <>
            <Modal show={openModal && !showModal} onHide={closeModal} className='searchable-checkbox-modal-content'>
                <Modal.Header closeButton>
                    <Modal.Title className='d-flex align-items-center'>
                        <div className="border rounded-circle d-flex justify-content-center align-items-center mx-2 content-icon" style={{ width: '50px', height: '50px' }}>
                            <img src={AddToList} alt="add-to-list" />
                        </div>
                        Add {selectedInfluencers.length} creator(s) to list
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Button className="w-100 py-3 my-3" onClick={() => { setShowModal(true) }}>Create new list</Button>
                    <MDBInput label="Search your lists" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                        {shortlists.length > 0 &&
                        <>
                    <div className="mt-3" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                        <MDBTable striped hover>
                            <MDBTableBody>
                                {shortlists.filter(item => item.name.toLowerCase().includes(searchText.toLowerCase())).map(item => (
                                    <tr key={item.id} className="d-flex align-items-center">
                                        <td className='d-flex align-items-center w-100'>
                                            <MDBCheckbox onChange={() => toggleShortlistSelection(item.id)} checked={selectedShortlists.includes(item.id)} />
                                            <div className="ms-3 w-100 d-flex align-items-center justify-content-center">
                                                <div className='content-icon me-2'>
                                                <img src={ListIcon} alt='list-icon' width={20} height={20} className='' /></div>
                                                <div className='w-100'>
                                                    <div className="fw-bold">{item.name}</div>
                                                    <div className="d-flex justify-content-between align-items-center ">
                                                        <small className="list-count text-muted">{item.influencerIds.split(",").length} creators</small>
                                                        <small className="list-created-by text-muted"><i>by {item.username}</i></small>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </MDBTableBody>
                        </MDBTable>
                    </div>
                    <Button className="w-100 py-3 my-3" onClick={handleAddToShortlist}>Add</Button>
                    </> }
                </Modal.Body>
            </Modal>
            
            {/* Create New List Modal */}
            <Modal show={showModal} onHide={() => setShowModal(false)} centered className='searchable-checkbox-modal-content'>
                <Modal.Header closeButton className='align-items-start'>
                    <Modal.Title>
                        <div className='d-flex'>
                            <div className="border rounded-circle d-flex justify-content-center align-items-center mx-2 content-icon" style={{ width: '70px', height: '70px' }}>
                                <img src={ListIcon} alt='list-icon' width={30} height={30} className='' />
                            </div>
                            <div className='new-list-heading'>
                                <p className='m-0'>Create New List</p>
                                <small className='new-list-sub-heading m-0 p-0'>{selectedInfluencers.length} creator will be added to this list.</small>
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Control type="text" value={listName} placeholder='Enter list name' onChange={(e) => setListName(e.target.value)} style={{padding: '14px 10px'}} />
                </Modal.Body>
                <Modal.Footer>
                    <Button className='w-100 py-3 my-3' onClick={handleAddNewShortlist}>Add</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default AddToShortlist;
